export default __webpack_public_path__ + "static/media/treatments.0ba54c03.svg";